import React from 'react';
import { colors, spacing, shadows } from '../../../design/tokens';

interface NavProps {
  user: any;
  getDashboardPath: () => string;
}

export const Navigation: React.FC<NavProps> = ({ user, getDashboardPath }) => {
  return (
    <nav style={{ 
      padding: `0 ${spacing.xl}`, 
      height: '72px',
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      backgroundColor: 'white',
      borderBottom: `1px solid ${colors.neutral[200]}`,
      position: 'sticky',
      top: 0,
      zIndex: 1000,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: spacing.sm }}>
        <div style={{ 
          width: '32px', 
          height: '32px', 
          backgroundColor: colors.brand.main, 
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '18px'
        }}>E</div>
        <div style={{ fontSize: '24px', fontWeight: 800, color: colors.neutral[1000], letterSpacing: '-0.5px' }}>Exibrain</div>
      </div>
      
      <div style={{ display: 'flex', gap: spacing.xl, alignItems: 'center' }}>
        <a href="#features" style={{ textDecoration: 'none', color: colors.neutral[600], fontWeight: 500, fontSize: '14px' }}>Features</a>
        <a href="#how-it-works" style={{ textDecoration: 'none', color: colors.neutral[600], fontWeight: 500, fontSize: '14px' }}>How it Works</a>
        
        <div style={{ width: '1px', height: '20px', backgroundColor: colors.neutral[200], margin: `0 ${spacing.sm}` }} />
        
        {user ? (
          <a href={getDashboardPath()} style={{ 
            textDecoration: 'none', 
            backgroundColor: colors.brand.main, 
            color: 'white', 
            padding: `10px 20px`, 
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: '14px',
          }}>Dashboard</a>
        ) : (
          <>
            <a href="/login" style={{ textDecoration: 'none', color: colors.neutral[900], fontWeight: 600, fontSize: '14px' }}>Login</a>
            <a href="/signup" style={{ 
              textDecoration: 'none', 
              backgroundColor: colors.neutral[1000], 
              color: 'white', 
              padding: `10px 20px`, 
              borderRadius: '6px',
              fontWeight: 600,
              fontSize: '14px',
            }}>Get Started</a>
          </>
        )}
      </div>
    </nav>
  );
};
